export const isProductExclusive = (productNumber, domain) => {
  if (domain === "NZ") {
    return !!nzExclusiveData[productNumber];
  } else if (domain === "AU") {
    return !!auExclusiveData[productNumber];
  } else {
    return false;
  }
};

const nzExclusiveData = {};

const auExclusiveData = {};
